import { render, staticRenderFns } from "./MessageDeleteConfirmation.vue?vue&type=template&id=5411c48e&scoped=true&"
import script from "./MessageDeleteConfirmation.vue?vue&type=script&lang=js&"
export * from "./MessageDeleteConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./MessageDeleteConfirmation.vue?vue&type=style&index=0&id=5411c48e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5411c48e",
  null
  
)

export default component.exports